import { render, staticRenderFns } from "./OpenCartStockEdit.vue?vue&type=template&id=4528c2f2&"
import script from "./OpenCartStockEdit.vue?vue&type=script&lang=js&"
export * from "./OpenCartStockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenCartStockEdit.vue"
export default component.exports